//@flow
import withHandledContractData from "./withHandledContractData";
import ContractCard from "./ContractCard";

const ConnectedContractCard = withHandledContractData(ContractCard);
export default ConnectedContractCard;